import state from './overviewState';
import { mutations, actions, getters } from './overview';

export default {
    state() {
        return { ...JSON.parse(JSON.stringify(state)), documents: {}, doctypes: [] };
    },
    mutations: {
        ...mutations,
        updateStep(state, info) {
            state.dataFetch.informations = info;
        },
        updateActiveStatus(state, status) {
            state.dataFetch.informations.find((index) => index.key === 'signed').value = status.id;
        },
        updateEndDate(state, endDate) {
            state.dataFetch.informations.find((index) => index.key === 'endDate').value = endDate;
            state.dataFetch.informations.find((index) => index.key === 'dueDate').value = endDate;
        },
        updateMainDocument(state, linkId) {
            const currentMainDocument = state.documents.find((document) => document.isMain);
            if (currentMainDocument) {
                currentMainDocument.isMain = false;
            }
            state.documents.find((document) => document.linkid === linkId).isMain = true;
        },
        updateDocuments(state, documents) {
            state.documents = documents;
        },
        updateDoctypes(state, doctypes) {
            state.doctypes = Object.values(doctypes);
        },
        updatePotentialAmount(state, amount) {
            state.dataFetch.informations.find((index) => index.key === 'potentialAmount').value =
                amount;
        },
        updateSharedStaff(state, staff) {
            state.sellsyInformations.sharedWithStaffs = staff;
        },
        updateSource(state, source) {
            state.dataFetch.informations.find((index) => index.key === 'sourceName').value =
                source.name;
            state.dataFetch.informations.find((index) => index.key === 'sourceId').value =
                source.id;
        },
    },
    actions: {
        ...actions,
        updateStep({ dispatch, commit }, info) {
            commit('updateStep', info);
        },
        updateEndDate({ dispatch, commit }, payload) {
            commit('updateEndDate', payload);
        },
        updateActiveStatus({ dispatch, commit }, payload) {
            commit('updateActiveStatus', payload.status);
            commit('updateEndDate', payload.endDate);
        },
        updateMainDocument({ state, commit }, linkid) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/?_f=prospection_opportunity&action=updateDefaultDocument`, {
                        oid: state.linkedid,
                        docleid: linkid,
                    })
                    .then(() => {
                        commit('updateMainDocument', linkid);
                        resolve();
                    })
                    .catch(() => {
                        reject();
                    });
            });
        },
        fetchDocuments({ commit }, linkedid) {
            return new Promise((resolve, reject) => {
                window.SellsyJS.WebServiceCaller.get(
                    `/rest/prospection/opportunities/${linkedid}/documents`,
                    {},
                    (response) => {
                        commit('updateDocuments', response.items);
                        commit('updateDoctypes', response.doctypes);
                        resolve();
                    },
                    () => {
                        reject();
                    },
                );
            });
        },
        updatePotentialAmount({ commit }, amount) {
            commit('updatePotentialAmount', amount);
        },
        updateSharedStaff({ commit }, staff) {
            commit('updateSharedStaff', staff);
        },
        updateSource({ commit }, source) {
            commit('updateSource', source);
        },
    },
    getters: {
        ...getters,
        activeStep: (state) => {
            return state.activeStep;
        },
        opportunityThird: (state) => {
            return state.dataFetch.third;
        },
        documents: (state) => {
            return state.documents;
        },
        doctypes: (state) => {
            return state.doctypes;
        },
    },
};
